import { notificationsAPI } from '../services/api';

export function isNotificationSupported() {
  const baseSupported = (
    typeof window !== 'undefined'
    && 'Notification' in window
    && typeof navigator !== 'undefined'
    && 'serviceWorker' in navigator
  );
  if (!baseSupported) return false;

  // WebKit may expose pushManager on the registration instance without exposing
  // either constructor used by synchronous feature detection.
  if (isIosDevice() && isStandalone()) return true;

  const pushSupported = (
    'PushManager' in window
    || (
      'ServiceWorkerRegistration' in window
      && 'pushManager' in window.ServiceWorkerRegistration.prototype
    )
  );
  return pushSupported;
}

export function isIosDevice() {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent || '');
}

export function isStandalone() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  return Boolean(
    navigator.standalone === true
    || window.matchMedia?.('(display-mode: standalone)').matches
  );
}

function urlBase64ToUint8Array(value) {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map(character => character.charCodeAt(0)));
}

export async function getCurrentPushSubscription() {
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
}

export async function enableNotificationDevice(publicKey) {
  const permission = await window.Notification.requestPermission();
  if (permission !== 'granted') {
    return { permission, subscription: null, response: null };
  }

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();
  let createdSubscription = false;

  try {
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
      createdSubscription = true;
    }
    const response = await notificationsAPI.subscribe({
      ...subscription.toJSON(),
      consent: 'granted',
    });
    return { permission, subscription, response };
  } catch (error) {
    if (createdSubscription && subscription) {
      try {
        await subscription.unsubscribe();
      } catch (rollbackError) {
        console.warn('Notification subscription rollback failed:', rollbackError?.message);
      }
    }
    throw error;
  }
}
